import { useEffect, useState } from 'react';
import { WatchlistApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { handleAdminError } from '../../common/SharedFunctions';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { formatDateMonthDayYear } from '@apply/ui';
import LoadPanel from 'devextreme-react/load-panel';

const GradeHistoryTable = ({ loanId }) => {
    const [data, set_data] = useState([]);
    const [loadingMessage, set_loadingMessage] = useState('');
    const watchlistApi = new WatchlistApi.WatchlistApi(applicationInsights);

    const formatDate = (dt) => {
        if (!dt) {
            return null;
        }
        return formatDateMonthDayYear(dt);
    };

    const onDateRender = (e) => {
        return formatDate(e.value);
    };

    const loadHistoryAsync = async (loanId) => {
        try {
            set_loadingMessage('Retrieving history...');
            const response = await watchlistApi.getGradeHistory(loanId);
            if (response.statusCode !== 200) {
                throw new Error('Failed to retrieve data!');
            }
            const records = response.result;
            set_data(records);
        } catch (ex) {
            handleAdminError(ex, 'Failed to retrieve records! Please refresh the page and try again.');
        } finally {
            set_loadingMessage('');
        }
    };

    useEffect(() => {
        if (!loanId) {
            return;
        }

        loadHistoryAsync(loanId);
    }, [loanId]);

    if (!loanId) {
        return null;
    }

    return (
        <>
            <DataGrid
                keyExpr={'id'}
                dataSource={data}
                rowAlternationEnabled={true}
                showBorders={true}
                showColumnHeaders={true}
                showRowLines={true}
                wordWrapEnabled={true}
                noDataText={'No grade history found for this loan'}
            >
                <Column
                    dataField='createdAt'
                    caption='Date'
                    width={100}
                    cellRender={onDateRender}
                    sortIndex={0}
                    sortOrder={'desc'}
                />
                <Column
                    dataField='grade'
                    caption='Grade'
                    width={60}
                    alignment='left'
                />
                <Column
                    dataField='reason'
                    caption='Reason'
                />
                <Column
                    dataField='userName'
                    caption='Changed By'
                    alignment='left'
                    width={150}
                />
            </DataGrid>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={!!loadingMessage}
                message={loadingMessage}
            />
        </>
    );
};

export default GradeHistoryTable;
